<kui-select [options]="comboValues"
    (change)="comboChanged($event, true)">
</kui-select>
<div *ngIf="error"
    class="invalid-feedback d-block">
    <div>{{ error }}</div>
</div>